export const initBlockData = {
  title: "Button block",
  showMore: {
    link: "/",
    text: "Show more",
  },
};

export const initEmptyBlockData = {
  title: "",
  showMore: {
    link: "/",
    text: "Show more",
  },
};
